import { $api } from "@/utils/fetch.ts";

// Customer-facing platform status banner. Polled so customers pick up an
// admin toggle without reloading (same cadence idea as the partner dashboard).
const REFETCH_INTERVAL_MS = 60 * 1000;

// One read for every caller, authenticated or not: the banner is a single
// global row with no tenant data, and the pre-login auth pages need it too. The
// `/api/public/` prefix is load-bearing — utils/fetch.ts exempts only that
// prefix from the session-expired flow, so a token-less read from anywhere else
// would clear the token and toast at anonymous visitors.
export const statusBannerQueryOptions = () =>
	$api.queryOptions(
		"get",
		"/api/public/status-banner",
		{},
		{ refetchInterval: REFETCH_INTERVAL_MS },
	);
